import { UserAdminRole } from "@/__generated__/graphql";

export const optionSpeaking = [
  { label: "All speaking types", value: undefined },
  { label: "Exam", value: "speaking" },
  { label: "School test", value: "speaking-domain" },
  { label: "Mini test", value: "mini-speaking" },
  { label: "Exercise", value: "exercise-speaking" },
];

export const optionExam = [
  { label: "All exam types", value: undefined },
  { label: "Exam", value: "exam" },
  { label: "School test", value: "exam-domain" },
  { label: "Mini test", value: "mini" },
  { label: "Exercise", value: "exercise-exam" },
];

export const optionWriting = [
  { label: "All writing types", value: "all" },
  { label: "Exam", value: "writing" },
  { label: "School test", value: "writing-domain" },
  { label: "Mini test", value: "mini-writing" },
  { label: "Exercise", value: "exercise-writing" },
];

export const ENVIRONMENT = {
  API_UPLOAD_ORIGIN: process.env.NEXT_PUBLIC_APP_UPLOAD_API,
  API_UPLOAD: `${process.env.NEXT_PUBLIC_APP_UPLOAD_API}/image?transparent=true`,
  API_UPLOAD_AUDIO: `${process.env.NEXT_PUBLIC_APP_UPLOAD_API}/audio`,
  IS_PRODUCT: `${process.env.NEXT_PUBLIC_ENVIRONMENT || "prod"}` === "prod",
  EXAM_URL: process.env.NEXT_PUBLIC_EXAM_URL || "https://exam.flyer.us",
  CHECK_POINT_EXAM_URL:
    process.env.NEXT_PUBLIC_EXAM_CHECK_POINT ||
    "https://exam-checkpoint.flyer.us",
  TEACHER_URL:
    process.env.NEXT_PUBLIC_TEACHER_URL ||
    "https://admin-teacher.flyer.vn", 
};

/**
 * Cờ bật các tool chỉ dành cho môi trường không phải product (ví dụ xoá user dev).
 * Khác `ENVIRONMENT.IS_PRODUCT`: biến env không set (chạy local) vẫn được coi là
 * môi trường dev, còn image product luôn có `NEXT_PUBLIC_ENVIRONMENT=prod`
 * (Dockerfile copy `.env.$APP_ENV`), nên tool bị ẩn ở đó.
 */
export const IS_DEV_TOOLS_ENABLED =
  `${process.env.NEXT_PUBLIC_ENVIRONMENT || "dev"}` !== "prod";

export const permissionEditCheckPoint = [
  UserAdminRole.Admin,
  UserAdminRole.ContentEditor,
  UserAdminRole.Tester,
];

export const permissionRoot = [UserAdminRole.Admin];
export const permissionRootManager = [UserAdminRole.Admin, "SUPER_MANAGER"];

export const permissionManager = [
  UserAdminRole.Admin,
  UserAdminRole.Manager,
  UserAdminRole.SuperManager,
];

export const DEFAULT_ROWS_PER_PAGE_OPTIONS = [10, 20, 50, 100, 250];
export const DEFAULT_CURRENT_PAGE = DEFAULT_ROWS_PER_PAGE_OPTIONS[0] || 20;

/**
 * Route GHI của kho quà đá tri thức: POST/PATCH/DELETE quà `scope='FLYER'`. Bề mặt duyệt đơn
 * (approve/reject/batch) đã bị xoá khỏi phía admin — duyệt là việc của trung tâm.
 *
 * Chốt bởi product 2026-08-19: `superAdminRoles` + TESTER. VIEWER và CONTENT_EDITOR bị loại.
 * Server vẫn là nơi cưỡng chế thật (403), UI chỉ ẩn nút cho đỡ ăn lỗi.
 *
 * Không dùng `permissionManager` — nó thiếu TESTER, đúng role cần test luồng end-to-end.
 */
export const permissionWisdomStoneStoreWrite = [
  UserAdminRole.Admin,
  UserAdminRole.Manager,
  UserAdminRole.SuperManager,
  UserAdminRole.Tester,
];

/**
 * Write routes of school documents: assign a slide theme, patch fields, delete.
 * VIEWER is read-only. The server still enforces this with 403; the UI only hides buttons.
 */
export const permissionSchoolDocumentWrite = [
  UserAdminRole.Manager,
  UserAdminRole.Admin,
  UserAdminRole.SuperManager,
  UserAdminRole.ContentEditor,
  UserAdminRole.Tester,
];
